/* eslint-disable */

import { AddOn } from './AddOn';
//import * as wording from '../../../common/js/wording'
import { AddOnType } from '../FbbEnum';
import * as log from '../../../common/js/appLogger';

/*
Pls submit “Z,1” for equipList plus below values (like Norton):

WiFi路由器	VAS Code	標準月費	Mktg code	收費總額	合約期(月)	合約代號	T&C
Asus RT-AC68U	FBRM1	$40	MVZ08	$960	24	LDJ24M40	N003PB
*/
export class AddOnRentalRouter extends AddOn {
	static readonly codesInfo = [
		/***{
            "contract":6,
            "avgPrice" : 65,
            "ignorePlanCode" : false,
            "planCodeAllowed" : ["5g_hbb_6m", "5g_hbb_FUTU_6m"],  // only these plans have different suffix
            "code" : "ADD-ROUTER-6RENT-WPRE2"
        },***/
		{
			contract: 6,
			avgPrice: 65,
			ignorePlanCode: true,
			planCodeAllowed: ['all'], // only these plans have different suffix
			code: 'ROUTER-RENTAL',
		},
		{
			contract: 12,
			avgPrice: 65,
			ignorePlanCode: false,
			planCodeAllowed: ['5g_hbb_Free3mths_12mth'],
			code: 'ADD-ROUTER-12RENT-NPRE',
		},
		{
			contract: 12,
			avgPrice: 65,
			ignorePlanCode: true,
			planCodeAllowed: ['all'], // only these plans have different suffix
			code: 'ROUTER-RENTAL',
		},
		/***{
            "contract":24,
            "avgPrice" : 65,
            "ignorePlanCode" : false,
            "planCodeAllowed" : ["5g_hbb_cv", "5g_hbb_FUTU_24m"],  // only these plans have different suffix
            "code" : "ADD-ROUTER-24RENT-CV"                    
        },
        {
            "contract":24,
            "avgPrice" : 65,
            "ignorePlanCode" : false,
            "planCodeAllowed" : ["5g_hbb_BKFREE1"],  // only these plans have different suffix
            "code" : "ADD-ROUTER-24RENT,ADD-ROUTER-DEPOSIT"                    
        },***/
		{
			contract: 24,
			avgPrice: 65,
			ignorePlanCode: false,
			planCodeAllowed: ['5g_hbb_YATA250'], // only these plans have different suffix
			code: 'ADD-ROUTER-24RENT-NPRE',
		},
		{
			contract: 24,
			avgPrice: 65,
			ignorePlanCode: true,
			planCodeAllowed: ['all'],
			code: 'ROUTER-RENTAL',
		},
		{
			contract: 30,
			avgPrice: 65,
			ignorePlanCode: false,
			planCodeAllowed: ['5g_hbb_SHKF2_30m'], // only these plans have different suffix
			code: 'ADD-ROUTER-30RENT-NPRE',
		},
		{
			contract: 30,
			avgPrice: 65,
			ignorePlanCode: true,
			planCodeAllowed: ['all'],
			code: 'ROUTER-RENTAL',
		},
		/***
        {
            "contract":36,
            "avgPrice" : 53,
            "ignorePlanCode" : true,
            "planCodeAllowed" : ["all"],      // only these plans are 36m ["5g_hbb_AS13836_36m", "5g_hbb_AS14836_36m"],
            "code" : "ADD-ROUTER-36RENT-NPRE"                    
        },***/
		{
			contract: 36,
			avgPrice: 65,
			ignorePlanCode: true,
			planCodeAllowed: ['all'],
			code: 'ROUTER-RENTAL',
		},
	];

	// ADD-ROUTER-24RENT-NPRE-INBASE
	// old code for wetland plan (30-mth contract): "ADD-ROUTER-30RENT-NPRE-WETLAND"

	protected isBasePlanSelected: boolean = false;
	protected baseVasCode: String = 'ADD-ROUTER-%m%RENT-NPRE'; // general for reference

	protected rentalMeshAmount: Number = 65;
	protected buyMeshAmount: Number = 1000;
	protected rentalMeshCount: Number = 0;
	protected buyMeshCount: Number = 0;
	//protected isRentalMeshSelected:boolean = false;
	//protected isBuyMeshSelected:boolean = false;

	constructor() {
		super();
		this.key = 'AddOnRentalRouter';

		this.boxIconEn = '';
		this.boxIconZh = '';
		this.boxNameEn = 'Router Rental';
		this.boxNameZh = 'Router Rental';
		this.boxAmount = 65; // per month
		this.discountAmount = -1; // 3080
		this.hasRedCounter = false;

		this.type = AddOnType.SINGLE;
	}

	public getAmount(contractMonthSrt: string): Number {
		let option = null;
		let contractMonth: Number = parseInt(contractMonthSrt);
		let displayPriceAmount = this.boxAmount;
		for (var i = 0; i < AddOnRentalRouter.codesInfo.length; i++) {
			if (AddOnRentalRouter.codesInfo[i].contract == contractMonth) {
				option = AddOnRentalRouter.codesInfo[i];
				break;
			}
		}

		if (option && option.hasOwnProperty('avgPrice') && option['avgPrice'] != displayPriceAmount) {
			displayPriceAmount = option.avgPrice;
		}

		return displayPriceAmount;
	}

	public getBaseVasCode(): String {
		return this.baseVasCode || '';
	}

	public isAddOnSelected(): boolean {
		return this.boxCount > 0;
	}

	//=================================================================================
	/** no overwrite AddOn one 
    public getData() : any {
        //var data = super.getData()
        return data
    }
    public parse(data: any) {
        //super.parse(data)
    }
    */
	//=================================================================================

	public getPlanVasCode2(contractMonth: Number, planCode: string): string {
		let vasCode;
		if (this.isAddOnSelected()) {
			let option = null;
			for (var i = 0; i < AddOnRentalRouter.codesInfo.length; i++) {
				if (AddOnRentalRouter.codesInfo[i].contract == contractMonth) {
					if ((AddOnRentalRouter.codesInfo[i].ignorePlanCode ?? false) == true) {
						option = AddOnRentalRouter.codesInfo[i];
						break;
					} else {
						if (AddOnRentalRouter.codesInfo[i].planCodeAllowed.indexOf(planCode) > -1) {
							option = AddOnRentalRouter.codesInfo[i];
							break;
						}
					}
				}
			}

			vasCode = option?.code ?? '';
			vasCode = vasCode.replace('%m%', contractMonth.toString());
			return vasCode;
		} else {
			return '';
		}
	}

	public getPlanVasCode(customerType: String, contractMonth: Number): string {
		let vasCode;
		if (this.isAddOnSelected()) {
			let option = null;
			for (var i = 0; i < AddOnRentalRouter.codesInfo.length; i++) {
				if (AddOnRentalRouter.codesInfo[i].contract == contractMonth) {
					option = AddOnRentalRouter.codesInfo[i];
					break;
				}
			}

			vasCode = option?.code ?? '';
			vasCode = vasCode.replace('%m%', contractMonth.toString());
			return vasCode;
		} else {
			return '';
		}
	}

	// mesh router:
	public isAddOnRentalMeshSelected(): boolean {
		return this.rentalMeshCount > 0;
	}
}
